import i18n from '@/i18n'
import jobDetailPage from './jobDetailPage'

export default {
  name: 'job-description',
  path: '/job-description/:jobId',
  component: jobDetailPage,
  meta: {
    noAuth: true,
    title: i18n.t('jobDetail.pageTitle')
  }
}
